/**
 * listing redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {
    FETCH_OBJECT_QUERY,
    DELETE_OBJECT,
    UNDELETE_OBJECT,
    UPDATE_SEARCH_INPUT
} from './consts';


export const updateSearchAction = (text) => ({
    type: UPDATE_SEARCH_INPUT,
    text: text
});

export const fetchObjectQueryAction = (objectList, objectAccessLevels, objectRefCounts) => ({
    type: FETCH_OBJECT_QUERY,
    objectList: objectList,
    objectAccessLevels: objectAccessLevels,
    objectRefCounts: objectRefCounts
});

export const deleteObjectAction = (id) => ({
    type: DELETE_OBJECT,
    id: id
});

export const undeleteObjectAction = (id) => ({
    type: UNDELETE_OBJECT,
    id: id
});
